<template>
    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="text-h6">Import Responses for {{ data.test_name }}</span>
        </v-card-title>
        <v-card-text>
          <!-- <div class="test-info-section">
            <div class="test-name">Test: {{ data.test_name }}</div>
            <div class="test-id">Test ID: {{ data.test_id }}</div>
          </div> -->
          <v-row>
            <v-col cols="12">
              <v-file-input 
                v-model="uploadedFile" 
                label="Upload Excel File" 
                accept=".xlsx,.xls" 
                dense
                outlined 
                placeholder="Select your file" 
                class="my-4" 
                prepend-icon="mdi-file-excel"
              ></v-file-input>
              <InputError :data='error.file' />
              <!-- <v-tooltip left bottom content-class="cust-new-tooltip-bottom">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    @click="downloadTemplate"
                    class="cust-btn"
                    v-on="on"
                    style="width: 100%;"
                  >
                    <v-icon center>mdi-download</v-icon> Download Template
                  </v-btn>
                </template>
                <span>Click to download the Excel template</span>
              </v-tooltip> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="danger" 
            class="cust-btn" 
            @click="cancelImport" 
            elevation="2"
          >
            Cancel
          </v-btn>
          <v-btn 
            color="primary" 
            class="cust-btn" 
            :loading="loading"
            :disabled="!uploadedFile" 
            @click="uploadFile" 
            elevation="2"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  export default {
    name: "ImportResponsesDialog",
    props: {
      onClose: Function,
      data: {
        type: Object,
        default: () => ({})
      },
      status: Boolean
    },
    data() {
      return {
        uploadedFile: null,
        loading: false,
        showDialog: false,
        error: {
          file: {
            type: null,
            message: null,
          }
        }
      };
    },
    watch: {
      status(newVal) {
        this.showDialog = newVal;
      },
      showDialog(newVal) {
        if (!newVal) {
          this.cancelImport();
        }
      }
    },
    methods: {
      ...mapActions({
        importTestResponses: "testStore/importTestResponses",
        downloadResponseTemplate: "testStore/downloadResponseTemplate",
      }),
      
      cancelImport() {
        this.uploadedFile = null;
        this.resetErrors();
        this.showDialog = false;
        this.onClose({
          status: false,
          action: "cancel"
        });
      },
      
      resetErrors() {
        this.error.file.type = null;
        this.error.file.message = null;
      },
      
      validateFile() {
        this.resetErrors();
        
        if (!this.uploadedFile) {
          this.error.file.type = 'error';
          this.error.file.message = 'Please select a file to upload';
          return false;
        }
        
        const allowedTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        
        if (!allowedTypes.includes(this.uploadedFile.type)) {
          this.error.file.type = 'error';
          this.error.file.message = 'Please select a valid Excel file (.xls or .xlsx)';
          return false;
        }
        
        return true;
      },
      
      async uploadFile() {
        if (!this.validateFile()) {
          return;
        }
  
        const formData = new FormData();
        formData.append("file", this.uploadedFile);
        formData.append("test_id", this.data.test_id);
  
        this.loading = true;
        
        try {
          const response = await this.importTestResponses(formData);
          this.$toasted.success(`${response.message}`, { 
            icon: 'check_circle', 
            className: 'new-class' 
          });
          
          this.showDialog = false;
          this.onClose({
            status: false,
            action: "success",
            reload: true
          });
        } catch (err) {
          console.error("Error importing responses:", err);
          // Error handling is done by the API interceptor
        } finally {
          this.loading = false;
        }
      },
      
      async downloadTemplate() {
        try {
          const reqData = {
            test_id: this.data.test_id
          };
          
          const response = await this.downloadResponseTemplate(reqData);
          
          if (response && response.url) {
            // Create download link
            const link = document.createElement('a');
            link.href = response.url;
            link.download = `response_template_test_${this.data.test_id}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          
          this.$toasted.success("Template downloaded successfully", { 
            icon: 'download' 
          });
        } catch (err) {
          console.error("Error downloading template:", err);
          this.$toasted.error("Error downloading template. Please try again.");
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .test-info-section {
    margin-bottom: 16px;
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
  
  .test-name {
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
  }
  
  .test-id {
    font-size: 14px;
    color: #666;
  }
  </style>
